import { atomWithReducer } from "jotai/utils";
import { questionnaireReducer } from "../reducer";
import { questionnaireInitialState } from "../reducer/initialState";

export const questionnaireReducerAtom = atomWithReducer(
  questionnaireInitialState,
  questionnaireReducer,
);
